export const formatCurrency = (amount) => {
  const num = Number(amount || 0);

  if (num % 1 === 0) {
    return num.toFixed(0);
  }

  return num.toFixed(2);
};
